(function() {
  let attachedCheckbox = null;

  function getCheckbox() {
    return document.getElementById('tnc-checkbox');
  }

  function getButtons() {
    return document.querySelectorAll('[name="checkout"], .cart__checkout-button');
  }

  function setButtonState(enabled) {
    getButtons().forEach(function(btn) {
      btn.classList.toggle('tnc-enabled', enabled);
    });
  }

  function blockCheckout(e) {
    const checkbox = getCheckbox();
    if (!checkbox || !checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const error = document.getElementById('tnc-error');
      if (error) error.style.display = 'block';
      if (checkbox) checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function attachCheckboxListener() {
    const checkbox = getCheckbox();
    if (!checkbox || checkbox === attachedCheckbox) return;

    checkbox.addEventListener('change', function() {
      const error = document.getElementById('tnc-error');
      if (checkbox.checked) {
        if (error) error.style.display = 'none';
        setButtonState(true);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'tnc_accepted': 'true',
              'tnc_timestamp': new Date().toISOString(),
              'tnc_policy_version': 'v1.0-2026-07-27'
            }
          })
        });
      } else {
        if (error) error.style.display = 'none';
        setButtonState(false);
      }
    });

    attachedCheckbox = checkbox;
  }

  function syncState() {
    const checkbox = getCheckbox();
    if (!checkbox) return;

    getButtons().forEach(function(btn) {
      btn.removeEventListener('click', blockCheckout);
      btn.addEventListener('click', blockCheckout);
    });

    setButtonState(checkbox.checked);
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        const hasButton = (n.classList && n.classList.contains('cart__ctas'))
          || (n.querySelector && n.querySelector('[name="checkout"]'));
        const hasCheckbox = n.id === 'tnc-wrapper'
          || (n.querySelector && n.querySelector('#tnc-checkbox'));
        if (hasButton || hasCheckbox) {
          setTimeout(function() {
            attachCheckboxListener();
            syncState();
          }, 0);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  attachCheckboxListener();
  syncState();
})();